import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { actions } from '../../../../RestockingState'
import BadgeValidationModal from '../../../../../../components/BadgeValidationModal/BadgeValidationModal'
import ConfirmOrRejectModal from 'src/features/base/components/ConfirmOrRejectModal'
import Modal from 'src/components/Modal'
import * as S from './ExitActionsModal.styles'

interface ExitActionsModalProps {
  show: boolean
  title: string
  dataTestId: string
  idPage: number | undefined
  onClose: () => any
  onSuccess: () => void
  logoffAction: () => void
  setShowExitActionsModal: React.Dispatch<React.SetStateAction<boolean>>
}

interface FormData {
  badgeSupervisor: string;
}

const ExitActionsModal: React.FC<ExitActionsModalProps> = ({
  show,
  title,
  dataTestId,
  idPage,
  onClose,
  setShowExitActionsModal,
  logoffAction,
  onSuccess,
}) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [showSupervisorConfirmationModal, setShowSupervisorConfirmationModal] = useState(false)
  const [logoff, setLogoff] = useState(false)

  const {
    register,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm<FormData>()

  const dispatch = useDispatch()

  const closeSupervisorConfirmationModal = () => {
    clearErrors('badgeSupervisor')
    setShowSupervisorConfirmationModal(false)
    setShowConfirmModal(true)
  }

  const closeConfirmModal = () => {
    setShowConfirmModal(false)
    setShowExitActionsModal(true)
  }

  const setLogoffAction = () => {
    setLogoff(true)
    setShowExitActionsModal(false)
    setShowConfirmModal(true)
  }

  const setInterruptRestockingAction = () => {
    setLogoff(false)
    setShowExitActionsModal(false)
    setShowConfirmModal(true)
  }

  const cancelAction = () => setShowExitActionsModal(false)

  const supervisorConfirmation = () => {
    setShowSupervisorConfirmationModal(true)
    setShowConfirmModal(false)
  }

  const unlinkOperator = () => {
    if (!idPage) return

    const badgeSupervisor = getValues('badgeSupervisor')

    if (!badgeSupervisor) {
      setError('badgeSupervisor', { message: 'Campo obrigatório' })
      return
    }

    dispatch(actions.operatorUnlink({
      badge: badgeSupervisor,
      idPage,
      onSuccess,
    }))
  }

  return (
    <>
      <Modal
        show={show}
        testId={dataTestId}
        centered
        title={title}
        closeButtonAction={onClose}
        closedButton
        body={(
          <S.Container>
            <S.CustomButton
              title='Sair'
              bgColor='confirm'
              hoverColor='confirmHover'
              letterColor='white'
              data-testid='logoff-button-test-id'
              onClick={setLogoffAction}
            />
            <S.CustomButton
              title='Interromper reposição'
              bgColor='cancel'
              hoverColor='cancelHover'
              letterColor='white'
              data-testid='interrupt-restocking-button-test-id'
              onClick={setInterruptRestockingAction}
            />
            <S.CustomButton
              title='Cancelar'
              bgColor='darkBlue'
              hoverColor='darkBlueHover'
              letterColor='white'
              data-testid='cancel-button-test-id'
              onClick={cancelAction}
            />
          </S.Container>
        )}
      />
      <ConfirmOrRejectModal
        show={showConfirmModal}
        title='Confirmar operação'
        description={
            logoff
              ? 'Deseja realmente sair?'
              : 'ATENÇÃO: Ao confirmar a operação você está liberando essa página para outros operadores.'
        }
        onConfirm={logoff ? logoffAction : supervisorConfirmation}
        onReject={closeConfirmModal}
        onClose={closeConfirmModal}
        dataTestId='confirm-exit-actions-modal-test-id'
      />
      <BadgeValidationModal
        show={showSupervisorConfirmationModal}
        title='Crachá do fiscal'
        dataTestId='supervisor-confirmation-modal-test-id'
        onClose={closeSupervisorConfirmationModal}
        actionFunction={unlinkOperator}
        register={register}
        inputName='badgeSupervisor'
        errors={errors.badgeSupervisor}
        errorMessage={errors.badgeSupervisor?.message}
      />
    </>

  )
}

export default ExitActionsModal
